import { useMemo, useState } from 'react';

import type { AnalyticsDateRange, AnalyticsPeriod } from '../services/agentAnalyticsApi';
import {
  DEFAULT_ANALYTICS_PERIOD,
  toAnalyticsPeriodQuery,
  type AnalyticsPeriodValue,
} from '../utils/analytics-period';

export interface UseAnalyticsPeriodResult {
  /** Valor do `PeriodPicker` */
  value: AnalyticsPeriodValue;
  onChange: (value: AnalyticsPeriodValue) => void;
  /** O que vai para os hooks de analytics */
  period: AnalyticsPeriod;
  range: AnalyticsDateRange | undefined;
}

/**
 * Estado do seletor de período das abas Análises / Saúde / Lacunas.
 * Começa em 7 dias; o intervalo personalizado é memorizado para não trocar
 * de identidade a cada render.
 */
export function useAnalyticsPeriod(): UseAnalyticsPeriodResult {
  const [value, setValue] = useState<AnalyticsPeriodValue>({ mode: DEFAULT_ANALYTICS_PERIOD });
  const query = useMemo(() => toAnalyticsPeriodQuery(value), [value]);
  return { value, onChange: setValue, period: query.period, range: query.range };
}
